<template>
  <div class="h5-page-eianFAQ">
    <div class="main-title">
      <h1>环保小智使用功能</h1>
      <h1>常见问题及解决方案</h1>
      <h3>……内容持续更新中……</h3>
    </div>
    <div class="faq-div">
      <h3 @click="getLastData()">[<u>返回上一级</u>]</h3>
    </div>
    <template v-if="questionList.length">
      <div class="faq-div" v-for="(item, index) in questionList" :key="index">
        <template v-if="item.contents.length">
          <h3 @click="item.showCFlag = !item.showCFlag">
            {{ item.title }}
            [<u><span v-if="item.showCFlag">收起</span><span v-else>展开</span></u>]
          </h3>
          <template v-if="item.showCFlag">
            <p v-for="(cItem, cIndex) in item.contents" :key="cIndex">
              <span v-if="cItem.indexOf('faqid') !== -1" @click="getNextData(Number(cItem.split('faqid=')[1]))"><u style="color: blue;">{{ cItem.split('faqid=')[0] }}</u></span>
              <img v-else-if="cItem.indexOf('http://' || 'https://') !== -1" :src="cItem">
              <span v-else>{{ cItem }}</span>
            </p>
          </template>
        </template>
        <template v-else>
          <h3 @click="getNextData(item.id)">
            {{ item.title }}
            [<u>点击前往</u>]
          </h3>
        </template>
      </div>
    </template>
    <template v-else>
      <div class="faq-div">
        <h3>
          该条目没有更多数据了~
        </h3>
      </div>
    </template>
  </div>
</template>

<script>
import api from '../../api/index'
export default {
  data () {
    return {
      id: 155,
      // questionList: [{
      //   id: 0,
      //   lastId: 155,
      //   title: '',
      //   contents: [
      //     'content1content1content1content1content1content1',
      //     'http://hbxz.qsyhbgj.com/admin/20230406/04.21.jpg',
      //     'content3content3content3content3content3content3content3content3'
      //   ],
      //   showCFlag: false
      // }],
      questionList: [],
      loading: null
    }
  },
  created () {},
  mounted () {
    console.log('mounted', this.$route.query.id, this.id)
    this.refreshIdThenGetData()
  },
  watch: {
    $route (to, from) {
      // console.log('watch', to, from)
      this.refreshIdThenGetData()
    }
  },
  methods: {
    refreshIdThenGetData () {
      if (this.$route.query.id) {
        if (Number(this.$route.query.id) <= 155 && Number(this.$route.query.id) < 999) {
          this.$router.push('h5FAQ')
        } else {
          this.id = Number(this.$route.query.id)
          this.getData(this.id)
        }
      } else {
        this.id = 155
        this.getData(this.id)
      }
    },
    getNextData (id) {
      console.log('id', id)
      this.$router.push(`h5FAQ?id=${id}`)
    },
    getLastData () {
      console.log('getLastData', this.id)
      if (this.id !== 155) {
        this.$router.back()
      } else {
        this.$toast.text('没有更多了')
      }
    },
    getData (id) {
      console.log('getData', id)
      this.loading = this.$toast.loading()
      api.cdIntelligentSearch({
        type: id
      }).then(res => {
        var listTempArr = []
        for (let ti = 0; ti < res.data.list1.length; ti++) {
          listTempArr.push(res.data.list1[ti])
          if (res.data.list2[ti]) { listTempArr.push(res.data.list2[ti]) }
          if (res.data.list3[ti]) { listTempArr.push(res.data.list3[ti]) }
        }
        // console.log('listTempArr', listTempArr)
        var tempArr = []
        listTempArr.forEach(item => {
          var taContents = item.questions.replace(/<\/p>/g, '').split('<p>').filter(tacItem => { return tacItem })
          var taTitle = taContents.shift()
          // console.log('ta', taTitle, taContents)
          tempArr.push({
            id: item.id,
            lastId: Number(item.type),
            title: taTitle,
            contents: taContents,
            showCFlag: false
          })
        })
        this.questionList = tempArr
        this.loading.hide()
      })
    }
  }
}
</script>

<style lang="scss">
.h5-page-eianFAQ {
  background: #f4f5f6;
  max-width: 750px;
  margin: 0 auto;
  .main-title {
    width: 100%;
    padding: 20px 0 20px;
    text-align: center;
  }
  .sth-top {
    border-top: 4px solid #fff;
  }
  .faq-div {
    width: calc(100% - 2 * 20px);
    padding: 10px 20px;
    border-top: 4px solid #fff ;
    h2, h3 {
      margin: 4px 0 4px;
    }
    p {
      line-height: 1.5em;
      text-indent: 2em;
      // padding: 0 1em;
    }
  }
}
</style>
